module.exports = __webpack_public_path__ + "61bca2872be7b37b479026896c86babf.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/square/pink@2x.png
// module id = 332
// module chunks = 0